import { ReactElement } from 'react'

import { getQuoteConvertEligibility } from '@features/invoices/utils/depositInvoices/getQuoteConvertEligibility'
import { getQuoteConvertEligibilityData } from '@features/invoices/utils/depositInvoices/getQuoteConvertEligibilityData'

import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { useQuote } from '../../../../contexts/quoteContext'
import { ConvertQuoteDropdown } from './elements/ConvertQuoteDropdown'
import { ConvertQuoteToFinalInvoiceButton } from './elements/ConvertQuoteToFinalInvoiceButton'
import { ConvertQuoteToInvoiceButton } from './elements/ConvertQuoteToInvoiceButton'

export const ConvertQuoteActions = (): ReactElement | null => {
  const { quote } = useQuote()
  const quoteId = String(quote?.id ?? '')
  const quoteStatus = quote?.status?.status

  const { url: regularUrl } = useOrganizationViewUrl(reactRoute.organization.invoices.getInvoiceFromQuoteRoute(quoteId))

  const { canShowConvertActions, canCreateDepositInvoice, isQuotePartiallyInvoiced } = getQuoteConvertEligibility(
    getQuoteConvertEligibilityData(quote),
  )

  if (!canShowConvertActions) {
    return null
  }

  if (isQuotePartiallyInvoiced) {
    return <ConvertQuoteToFinalInvoiceButton />
  }
  if (canCreateDepositInvoice) {
    return <ConvertQuoteDropdown regularUrl={regularUrl} quote={quote} quoteStatus={quoteStatus} />
  }

  return <ConvertQuoteToInvoiceButton />
}
